<template>
	<section>
		<b-modal
			ref="modalLogin"
			ok-title="Acceder"
			hide-header
			hide-footer
			centered
			no-close-on-backdrop
			no-close-on-esc
			hide-backdrop
			no-fade
			>
			<b-overlay :show="loading" no-wrap></b-overlay>
			<div class="text-center">
				<img :src="logo" style="max-width: 200px">
				<h3 class="text-center">Update your password</h3>
			</div>
			<hr>
			<b-form v-if="!updateOk && !error" ref="loginForm" @submit="onSubmit">
				<div class="row justify-content-md-center">
					<div class="col-sm-8">
						<b-form-group label="Password">
							<b-form-input
								v-model="form.password"
								type="password"
								required
							></b-form-input>
						</b-form-group>
						<b-form-group label="Repeat password">
							<b-form-input
								v-model="form.passwordRepeat"
								type="password"
								required
							></b-form-input>
						</b-form-group>
					</div>
				</div>
				<div class="text-center">
					<br>
					<b-button variant="primary" type="submit" >Update password</b-button>
				</div>
			</b-form>
			<div v-if="updateOk" class="text-center">
				<p>Your password has been updated</p>
				<a href="/login" @click="$root.setRouteEvt">LOGIN</a>
			</div>
			<div class="text-center" v-if="error">
				<p>The password change request has expired</p>
				<a href="/login" @click="$root.setRouteEvt">LOGIN</a>
			</div>
		</b-modal>
	</section>
</template>

<script>
import logo from '../../../assets/logo-sc-negro.png'

export default {
  components: {  },
  data(){
	return {
		updateOk:false,
		logo,
		form : {
			token:this.$root.getParams().token,
			password:'',
			passwordRepeat:'',
		},
		error:false,
		loading:false,
	}
  },
  methods:{
	resetPass(event){
		console.log(event)
	},
	onSubmit(evt){
		evt.preventDefault();
		this.error = false;
		if (this.form.password === this.form.passwordRepeat) {
			this.loading = true;
			this.$root.api.post('/auth/update-password',this.form).then(() => {
				this.updateOk = true
				this.loading = false;
			}).catch(()=>{
				// this.updateOk = true
				this.error = true;
				this.loading = false;
			})
		}else{
			alert('Passwords are not the same')
		}
	},
  },
  mounted(){
	this.$refs['modalLogin'].show();
  }
}
</script>

<style>

</style>
